import { useState, useEffect } from 'react';
import { ADMIN_ENDPOINTS, adminFetch } from '../config';
import './Admin.css';

export default function AdminSkills() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // { type: 'cat'|'sub'|'item', parentId?, item? }
  const [form, setForm] = useState({ title: '', sort_order: 0, category_id: '', subcategory_id: '' });
  const [saving, setSaving] = useState(false);

  const load = () => {
    adminFetch(ADMIN_ENDPOINTS.fetchSkillsAdmin)
      .then((r) => r.json())
      .then((data) => {
        if (!data.error) setCategories(Array.isArray(data) ? data : []);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openModal = (type, parentId, item) => {
    setModal({ type, parentId, item });
    setForm({
      title: item?.title || '',
      sort_order: item?.sort_order ?? 0,
      category_id: parentId || (item && type === 'sub' ? item.category_id : null) || (item && type === 'item' ? categories.find((c) => c.subcategories?.some((s) => s.id === item.subcategory_id))?.id : null) || '',
      subcategory_id: parentId || (item && type === 'item' ? item.subcategory_id : null) || '',
    });
  };

  const saveCategory = async () => {
    setSaving(true);
    const res = await adminFetch(ADMIN_ENDPOINTS.saveSkillsCategory, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(modal?.item?.id ? { id: modal.item.id, title: form.title, sort_order: form.sort_order } : { title: form.title, sort_order: form.sort_order }),
    });
    const data = await res.json();
    setSaving(false);
    if (data.ok) { load(); setModal(null); } else alert(data.error || 'Failed');
  };

  const saveSubcategory = async () => {
    setSaving(true);
    const catId = form.category_id || modal?.parentId;
    const res = await adminFetch(ADMIN_ENDPOINTS.saveSkillsSubcategory, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(modal?.item?.id ? { id: modal.item.id, category_id: catId, title: form.title, sort_order: form.sort_order } : { category_id: catId, title: form.title, sort_order: form.sort_order }),
    });
    const data = await res.json();
    setSaving(false);
    if (data.ok) { load(); setModal(null); } else alert(data.error || 'Failed');
  };

  const saveItem = async () => {
    setSaving(true);
    const subId = form.subcategory_id || modal?.parentId;
    const res = await adminFetch(ADMIN_ENDPOINTS.saveSkillsItem, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(modal?.item?.id ? { id: modal.item.id, subcategory_id: subId, title: form.title, sort_order: form.sort_order } : { subcategory_id: subId, title: form.title, sort_order: form.sort_order }),
    });
    const data = await res.json();
    setSaving(false);
    if (data.ok) { load(); setModal(null); } else alert(data.error || 'Failed');
  };

  const handleSave = () => {
    if (modal?.type === 'cat') saveCategory();
    else if (modal?.type === 'sub') saveSubcategory();
    else if (modal?.type === 'item') saveItem();
  };

  const deleteCat = async (id) => { if (!window.confirm('Delete category and all subcategories/items?')) return; const r = await adminFetch(ADMIN_ENDPOINTS.deleteSkillsCategory, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id }) }); if ((await r.json()).ok) load(); };
  const deleteSub = async (id) => { if (!window.confirm('Delete?')) return; const r = await adminFetch(ADMIN_ENDPOINTS.deleteSkillsSubcategory, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id }) }); if ((await r.json()).ok) load(); };
  const deleteItem = async (id) => { if (!window.confirm('Delete?')) return; const r = await adminFetch(ADMIN_ENDPOINTS.deleteSkillsItem, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id }) }); if ((await r.json()).ok) load(); };

  if (loading) return <p>Loading…</p>;

  return (
    <>
      <h1>Skills</h1>
      {categories.map((cat) => (
        <div key={cat.id} className="card">
          <h2>
            {cat.title}
            <button type="button" className="btn btn-sm" onClick={() => openModal('cat', null, cat)}>Edit</button>
            <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteCat(cat.id)}>Delete</button>
          </h2>
          {(cat.subcategories || []).map((sub) => (
            <div key={sub.id} style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <strong>{sub.title}</strong>
              <button type="button" className="btn btn-sm" onClick={() => openModal('sub', cat.id, sub)}>Edit</button>
              <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteSub(sub.id)}>Delete</button>
              <ul style={{ margin: '0.5rem 0 0 1.5rem', padding: 0 }}>
                {(sub.items || []).map((item) => (
                  <li key={item.id}>
                    {item.title}
                    <button type="button" className="btn btn-sm" onClick={() => openModal('item', sub.id, item)}>Edit</button>
                    <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteItem(item.id)}>Delete</button>
                  </li>
                ))}
              </ul>
              <button type="button" className="btn btn-sm" onClick={() => openModal('item', sub.id, null)}>+ Add item</button>
            </div>
          ))}
          <button type="button" className="btn btn-sm" onClick={() => openModal('sub', cat.id, null)}>+ Add subcategory</button>
        </div>
      ))}
      <div className="card">
        <button type="button" className="btn" onClick={() => openModal('cat', null, null)}>+ Add category</button>
      </div>

      {modal && (
        <div className="admin-modal-backdrop" onClick={() => setModal(null)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>
                {modal.type === 'cat' && (modal.item ? 'Edit Category' : 'Add Category')}
                {modal.type === 'sub' && (modal.item ? 'Edit Subcategory' : 'Add Subcategory')}
                {modal.type === 'item' && (modal.item ? 'Edit Item' : 'Add Item')}
              </h2>
              <button type="button" className="admin-modal-close" onClick={() => setModal(null)}>&times;</button>
            </div>
            <div className="admin-modal-body">
              {modal.type === 'sub' && !modal.item && (
                <div className="form-group">
                  <label>Category</label>
                  <select value={form.category_id} onChange={(e) => setForm((f) => ({ ...f, category_id: e.target.value }))}>
                    <option value="">Select</option>
                    {categories.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}
                  </select>
                </div>
              )}
              {modal.type === 'item' && (
                <div className="form-group">
                  <label>Subcategory</label>
                  <select value={form.subcategory_id} onChange={(e) => setForm((f) => ({ ...f, subcategory_id: e.target.value }))}>
                    <option value="">Select</option>
                    {categories.flatMap((c) => (c.subcategories || []).map((s) => <option key={s.id} value={s.id}>{c.title} → {s.title}</option>))}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label>Title</label>
                <input type="text" value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} required />
              </div>
              <div className="form-group">
                <label>Sort order</label>
                <input type="number" value={form.sort_order} onChange={(e) => setForm((f) => ({ ...f, sort_order: parseInt(e.target.value, 10) || 0 }))} />
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-success" onClick={handleSave} disabled={saving || !form.title.trim()}>{saving ? 'Saving…' : 'Save'}</button>
                <button type="button" className="btn btn-ghost btn-sm" onClick={() => setModal(null)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
